export const ACCENT = {
  blue: "#1f4f85",
  blueDeep: "#123057",
  blueSoft: "rgba(31,79,133,0.14)",
};

export const BLUE_SHADES = [
  "#0f2745",
  "#173b68",
  "#1f4f85",
  "#2a5f97",
  "#3d79b7",
  "#5a95d1",
  "#84b3dd",
  "#afcde8",
  "#d4e3f3",
];

export const BLUE_SHADES_HOVER = [
  "#0b1d34",
  "#0f2745",
  "#173b68",
  "#1f4f85",
  "#2a5f97",
  "#3d79b7",
  "#4a87c6",
  "#6ca3d5",
  "#96beda",
  "#bfd6ea",
];

export const pickBlueShades = (count, palette = BLUE_SHADES) => {
  if (!Number.isFinite(count) || count <= 0) return [];
  if (count === 1) return [palette[2]];
  const max = palette.length - 1;
  return Array.from({ length: count }, (_, index) => {
    const paletteIndex = Math.round((index / (count - 1)) * max);
    return palette[paletteIndex];
  });
};

export const PIE_COLORS = [...BLUE_SHADES];
export const PIE_HOVER = [...BLUE_SHADES_HOVER];
